export default __webpack_public_path__ + "static/media/image-homepage-hero@2x.0dc246d4.jpg";